import { parallax } from '@immutabl3/alchemy/three';
import animation from './cameraCenterCorrection.animation.json';

export default function CameraCenterCorrection({ children }) {
  return (
    <parallax.group
      beaker="chapter1"
      animation={ animation }
    >
      { children }
    </parallax.group>
  );
};